import { gql } from '@/utils/graphql';

import { imagefragment } from './image';

export const cardShowFragment = gql`
	fragment cardShowFragment on Event {
		id: databaseId
		uptitle
		title(format: RENDERED)
		subtitle
		startDate
		endDate
		datesString
		acf: eventCustomFields {
			card {
				size
				imageFormat
				highlighted
				label {
					title
					text
				}
			}
			specialMention
			isEvent
			isAroundTheShow
			hasDetailPage
			ticketLink
			ticketButtonText
			hasDetailPage
			production: relatedProductions {
				nodes {
					id: databaseId
				}
			}
			datesEvent {
				date
				ticketLink
				ticketButtonText
			}
			publics: publicCardShow {
				nodes {
					... on Public {
						id: databaseId
						title: name
						icon: publicCustomFields {
							img: icon {
								node {
									...imageFragment
								}
							}
						}
					}
				}
			}
		}
		link
		image: featuredImage {
			node {
				...imageFragment
			}
		}
		excerpt(format: RENDERED)
		locations {
			nodes {
				name
			}
		}
		genres {
			nodes {
				id: slug
				name
			}
		}
		publics {
			nodes {
				id: slug
				name
			}
		}
		thematics {
			nodes {
				id: slug
				name
				description
				acf: thematicCustomFields {
					link
				}
			}
		}
		seasons {
			nodes {
				id: databaseId
				name
			}
		}
		festivals {
			nodes {
				slug
			}
		}
	}
	${imagefragment}
`;
